<div class="b2b-breadcrumb">
  <div>
    <ul class="breadcrumb">
      @if (compData?.container?.data?.length > 0) {
        @for (containerItem of compData?.container?.data; track containerItem; let last = $last) {
          <li class="{{textColor}}">
            @if (!last) {
              <a
                [href]="containerItem?.navigationURL"
                [style.color]="linkColor"
              >{{ containerItem?.title }}</a>
            }
            @if (last) {
              <span
                [style.color]="textColor"
              >{{ containerItem?.title }}</span>
            }
          </li>
        }
      }
      @if (breadcrumbs?.length > 0) {
        @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
          <li class="{{textColor}}">
            @if (!last) {
              <a
                [style.color]="linkColor"
                [href]="breadcrumb?.title">{{ breadcrumb?.briefDesc }}</a>
            }
            @if (last) {
              <span
                [style.color]="textColor"
              >{{ breadcrumb?.briefDesc }}</span>
            }
          </li>
        }
      }
    </ul>
  </div>
</div>
